import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { NavBar } from '@/components/layout/NavBar'
import { ScrollToTop } from '@/components/layout/ScrollToTop'
import { Dashboard } from '@/components/dashboard/Dashboard'
import { InstructorPage } from '@/components/instructor/InstructorPage'
import { InstructorsListPage } from '@/components/instructor/InstructorsListPage'
import { ThemeDeepDivePage } from '@/components/instructor/ThemeDeepDivePage'

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/instructors" element={<InstructorsListPage />} />
        <Route path="/instructors/:id" element={<InstructorPage />} />
        <Route path="/instructors/:id/themes/:theme" element={<ThemeDeepDivePage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
